import styled from 'styled-components';
import { rgba } from 'polished';

export const Menu = styled.ul`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	margin: 0;
	padding: 0;
	list-style: none;

	li {
		position: relative;
		outline: 0;

		&.first {
			margin-top: 2rem;
		}
	}
`;

export const MenuLabel = styled.span`
	transform: translateX(-0.25rem);
	white-space: nowrap;
`;

export const MenuItem = styled.li`
	a {
		display: flex;
		align-items: center;
		flex-flow: row nowrap;
		transition: color 100ms,
			background-color 100ms,
			border-left-color 100ms;
		border: 0;
		border-left-width: 0.125rem;
		border-left-style: solid;
		border-left-color: ${({ theme, isActive }) => isActive ? theme['blue-base'] : 'transparent'};
		background-color: transparent;
		padding: 0;
		color: ${({ theme, isActive }) => isActive ? theme['white'] : rgba(theme['white'], 0.3)};
		font-size: 0.9rem;
		font-weight: 700;

		svg {
			margin: 1rem 1.375rem;
			transition: opacity 100ms;
			opacity: 0.3;

			path,
			rect {
				fill: ${({ theme }) => theme['white']};
			}
		}

		&:hover {
			background: ${({ theme }) => theme['midnight-lighten-10']};
			color: ${({ theme }) => theme['white']};

			svg {
				opacity: 1;
			}
		}

		&:focus {
			outline: 0;
		}
	}
`;

export const MenuLinkBtn = styled.button`
	display: flex;
	align-items: center;
	flex-flow: row nowrap;
	transition: color 100ms,
		background-color 100ms,
		border-left-color 100ms;
	border: 0;
	border-left-width: 0.125rem;
	border-left-style: solid;
	border-left-color: ${({ theme, isActive }) => isActive ? theme['blue-base'] : 'transparent'};
	background-color: transparent;
	padding: 0;
	color: ${({ theme, isActive }) => isActive ? theme['white'] : rgba(theme['white'], 0.3)};
	font-size: 0.9rem;
	font-weight: 700;

	svg {
		margin: 1rem 1.375rem;
		transition: opacity 100ms;
		opacity: 0.3;

		path,
		rect {
			fill: ${({ theme }) => theme['white']};
		}
	}

	&:hover {
		background: ${({ theme }) => theme['midnight-lighten-10']};
		color: ${({ theme }) => theme['white']};

		svg {
			opacity: 1;
		}
	}

	&:focus {
		outline: 0;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-flow: column;
	justify-content: space-between;
	height: 100%;
	width: ${({ isMaximized }) => isMaximized ? '12rem' : 'auto'};

	.badge {
		position: absolute;
		top: 0.325rem;
		right: auto;
		left: 2.325rem;
	}

	[data-tooltip] {
		&::before,
		&::after {
			visibility: ${({ isMaximized }) => isMaximized ? 'hidden' : 'visible'};
			transition-delay: 0s;
		}

		&::after {
			width: 7rem;
		}

		&:hover {
			&::before,
			&::after {
				transition-delay: 0.5s;
			}
		}
	}

	${MenuLinkBtn} {
		width: ${({ isMaximized }) => isMaximized ? '100%' : 'auto'};
	}

	${MenuLabel} {
		display: ${({ isMaximized }) => isMaximized ? 'block' : 'none'};
	}
`;
